import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button, Card, CardBody, CardTitle, Col, Container, Input, Label, Row, Spinner, Alert
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Web için Google Autocomplete kütüphanesi
import Autocomplete from "react-google-autocomplete";

// --- MESAFE HESAPLAMA (HAVERSINE FORMÜLÜ) ---
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; 
}

const YeniGorevOlustur = () => {
  document.title = "Yeni Görev Oluştur | HarmanaGEL";
  const navigate = useNavigate();

  // BURAYA KENDİ GOOGLE MAPS API KEY'İNİ YAZMALISIN
  const GOOGLE_API_KEY = "AIzaSyAreftFsmXDb_jKD0kLYjQslxLkd-qwh08"; 

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const loggedInUserId = authUser?.ID; // Giriş yapan kişi (Varsayılan seçim için)
  const BASE_URL = "https://harmanagelapi.stechomeyazilim.info";

  // --- STATE'LER ---
  const [loading, setLoading] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [alertConfig, setAlertConfig] = useState({ visible: false, message: "", type: "success" });

  // Kullanıcı Seçimi
  const [users, setUsers] = useState([]);
  const [selectedTaskUser, setSelectedTaskUser] = useState(loggedInUserId || "");

  // Rota ve Koordinatlar
  const [startAddress, setStartAddress] = useState("");
  const [startLat, setStartLat] = useState(0);
  const [startLng, setStartLng] = useState(0);

  const [endAddress, setEndAddress] = useState("");
  const [endLat, setEndLat] = useState(0);
  const [endLng, setEndLng] = useState(0);
  
  const [km, setKm] = useState("");
  const [advertNote, setAdvertNote] = useState("");
  
  // Ayarlar ve Görev Tipi
  const [settings, setSettings] = useState(null);
  const [advertTypes, setAdvertTypes] = useState([]);
  const [advertTypeId, setAdvertTypeId] = useState(null);
  const [basePrice, setBasePrice] = useState("0");

  // Zaman
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [timeStart, setTimeStart] = useState("");
  const [timeEnd, setTimeEnd] = useState("");

  // Araç
  const [cars, setCars] = useState([]);
  const [selectedCarId, setSelectedCarId] = useState("new"); // Varsayılan "new" (yeni araç)
  const [carForm, setCarForm] = useState({
    carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: ""
  });

  // Ekstralar
  const [pricingOptions, setPricingOptions] = useState([]);
  const [selectedExtras, setSelectedExtras] = useState({});

  // --- YARDIMCI FONKSİYONLAR ---
  const showAlert = (message, type = "success") => {
    setAlertConfig({ visible: true, message, type });
    setTimeout(() => setAlertConfig({ visible: false, message: "", type: "success" }), 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };

  const normalizePlate = (p) => (p || "").toUpperCase().replace(/\s+/g, "").replace(/-/g, "").trim();

  // --- 1. BAŞLANGIÇ VERİLERİNİ YÜKLEME (Araçlar Hariç) ---
  useEffect(() => {
    const loadInitialData = async () => {
      setLoading(true);
      try {
        // Kullanıcıları Roller ile birlikte çekiyoruz
        const usersRes = await fetch(`${BASE_URL}/KULLANICILAR?$expand=HESAP_TURU`);
        const usersData = await usersRes.json();
        setUsers(usersData.value || []);

        const typeRes = await fetch(`${BASE_URL}/ILANLAR_Type`);
        const typeData = await typeRes.json();
        const types = typeData.value || typeData;
        setAdvertTypes(types);
        if (types.length > 0) setAdvertTypeId(types[0].ID);

        const pricingRes = await fetch(`${BASE_URL}/ILANLAR_Pricing`);
        const pricingData = await pricingRes.json();
        setPricingOptions(pricingData.value || pricingData.data || pricingData || []);

        const settingsRes = await fetch(`${BASE_URL}/Settings?$top=1`);
        const settingsData = await settingsRes.json();
        setSettings(settingsData.value?.[0] || null);

      } catch (error) {
        console.error("Veri yükleme hatası:", error);
        showAlert("Başlangıç verileri yüklenirken hata oluştu.", "danger");
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, []);

  // --- 2. SEÇİLEN KULLANICIYA GÖRE ARAÇLARI YÜKLEME ---
  useEffect(() => {
    const fetchUserCars = async () => {
        if (!selectedTaskUser) {
            setCars([]);
            return;
        }
        try {
            const carRes = await fetch(`${BASE_URL}/KULLANICILAR_Car?$filter=KULLANICI_ID eq ${selectedTaskUser}&$orderby=ID desc`);
            const carData = await carRes.json();
            setCars(carData.value || []);
            
            // Kullanıcı değiştiğinde formu ve seçimi sıfırla
            setSelectedCarId("new"); 
            setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" });
        } catch (error) {
            console.error("Araçlar yüklenirken hata:", error);
        }
    };
    fetchUserCars();
  }, [selectedTaskUser]);

  // --- OTOMATİK MESAFE (KM) HESAPLAMA ---
  useEffect(() => {
    if (startLat && startLng && endLat && endLng) {
      const calculatedDistance = getDistanceFromLatLonInKm(startLat, startLng, endLat, endLng);
      setKm(calculatedDistance.toFixed(2));
    } else {
      setKm("");
    }
  }, [startLat, startLng, endLat, endLng]);

  // Görev Tipi değiştiğinde Base Price güncelle
  useEffect(() => {
    if (!settings || !advertTypeId) return;
    
    const selectedType = advertTypes.find(t => t.ID === advertTypeId);
    const typeTitle = (selectedType?.Advert_Type_Title || "").toLowerCase();
    const isDriver = typeTitle.includes("sürücü") || typeTitle.includes("surucu");
    
    const price = isDriver ? settings.Km_Price_Car : settings.Km_Price_;
    setBasePrice(price?.toString() || "0");
  }, [settings, advertTypeId, advertTypes]);

  // Kayıtlı araç seçildiğinde formu doldur
  const handleCarSelect = (e) => {
    const val = e.target.value;
    setSelectedCarId(val);
    if (val !== "new" && val !== "") {
      const c = cars.find(x => x.ID.toString() === val);
      if (c) {
        setCarForm({
          carPlate: c.PLAKA || "",
          carBrand: c.MARKA || "",
          carModel: c.Users_Car_Model || "",
          carBodyType: c.Car_Body_Type || "",
          engineType: c.Engine_Type || "",
          chassisInformation: c.ChassisInformation || ""
        });
      }
    } else {
      setCarForm({ carPlate: "", carBrand: "", carModel: "", carBodyType: "", engineType: "", chassisInformation: "" });
    }
  };

  // --- FİYAT HESAPLAMALARI ---
  const totalPrice = useMemo(() => {
    const distance = parseFloat(km) || 0;
    const pricePerKm = parseFloat(basePrice) || 0;
    const subTotal = distance * pricePerKm;

    const extraTotal = pricingOptions.reduce((sum, item) => {
      const isSelected = !!selectedExtras[item.ID];
      const itemPrice = parseFloat(item.Price) || 0;
      return sum + (isSelected ? itemPrice : 0);
    }, 0);

    return subTotal + extraTotal;
  }, [km, basePrice, selectedExtras, pricingOptions]);

  // --- GÖNDERİM (PUBLISH) İŞLEMİ ---
  const handlePublish = async () => {
    if (!selectedTaskUser) {
        showAlert("Lütfen görev sahibi kullanıcıyı seçin.", "danger");
        return;
    }
    if (!startAddress || !endAddress || !km || !carForm.carPlate || !advertTypeId) {
      showAlert("Lütfen rota ve araç bilgilerini eksiksiz doldurun.", "danger");
      return;
    }
    if (!startDate || !endDate || !timeStart || !timeEnd) {
      showAlert("Lütfen başlangıç ve bitiş tarih/saatlerini eksiksiz girin.", "danger");
      return;
    }

    setPublishing(true);
    try {
      const startDT = new Date(startDate);
      const [sh, sm] = timeStart.split(":");
      startDT.setHours(sh, sm, 0);

      const endDT = new Date(endDate);
      const [eh, em] = timeEnd.split(":");
      endDT.setHours(eh, em, 0);

      if (endDT <= startDT) {
        showAlert("Bitiş zamanı başlangıçtan sonra olmalıdır.", "danger");
        setPublishing(false);
        return;
      }

      // Araç İşlemleri
      let finalCarId = selectedCarId === "new" || selectedCarId === "" ? null : parseInt(selectedCarId);

      if (!finalCarId) {
        const normPlate = normalizePlate(carForm.carPlate);
        const existing = cars.find(c => normalizePlate(c.PLAKA) === normPlate);
        
        if (existing) {
          finalCarId = existing.ID;
        } else {
          const carRes = await fetch(`${BASE_URL}/KULLANICILAR_Car`, {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              PLAKA: carForm.carPlate, MARKA: carForm.carBrand,
              Users_Car_Model: carForm.carModel, Car_Body_Type: carForm.carBodyType,
              Engine_Type: carForm.engineType, ChassisInformation: carForm.chassisInformation,
              Users_ID: parseInt(selectedTaskUser) // Seçilen kullanıcıya aracı ekliyoruz
            })
          });
          const carData = await carRes.json();
          finalCarId = carData?.value?.[0]?.ID || carData?.ID;
        }
      }

     // İlan Oluştur (Advert)
      const diffMs = endDT.getTime() - startDT.getTime();
      const totalMin = Math.max(0, Math.round(diffMs / 60000));
      const hh = String(Math.floor(totalMin / 60)).padStart(2, "0");
      const mm = String(totalMin % 60).padStart(2, "0");
      const estimatedDuration = `${hh}:${mm}`;

      const advertRes = await fetch(`${BASE_URL}/ILANLAR`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          OLUSTURMA_TARIHI: new Date().toISOString(),
          Advert_DateTime: startDT.toISOString(), Advert_DateTime2: endDT.toISOString(),
          Is_Active: true, 
          Users_ID: parseInt(selectedTaskUser), // İlanı seçilen kullanıcı adına oluşturuyoruz
          Price: parseFloat(totalPrice.toFixed(2)),
          Advert_Type_ID: advertTypeId, Car_ID: finalCarId, Estimated_Duration: estimatedDuration,
          Is_AdminCheck: false,
          Advert_Note: advertNote 
        })
      });

      const advertData = await advertRes.json();
      const createdAdvertId = advertData?.value?.[0]?.ID || advertData?.ID;

      if (!createdAdvertId) throw new Error("İlan oluşturulamadı (Sunucudan ID dönmedi).");

      // Rota Oluştur (Location)
      await fetch(`${BASE_URL}/KULLANICI_ADRESLERI`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Advert_ID: createdAdvertId, 
          Km: parseFloat(km),
          ADRESLER_StartAddress: startAddress, 
          ADRESLER_FinishAddress: endAddress,
          ADRESLER_Lat_Start: parseFloat(startLat), 
          ADRESLER_Long_Start: parseFloat(startLng),
          ADRESLER_Lat_Finish: parseFloat(endLat), 
          ADRESLER_Long_Finish: parseFloat(endLng)
        })
      });

     // Ana Fiyat Oluştur
      await fetch(`${BASE_URL}/ILANLAR_Pricing`, {
        method: "POST", 
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
            Advert_ID: createdAdvertId, 
            Advert_Pricing_Title: "Görev Ücretlendirmesi",
            Advert_Pricing_Desc: `${km} KM x ${basePrice}TL birim fiyat`, 
            Price: parseFloat(totalPrice.toFixed(2))
        })
      });

      // Ekstraları Kaydet
      const selectedPricingIds = Object.entries(selectedExtras).filter(([_, v]) => v).map(([k]) => Number(k));
      for (let pId of selectedPricingIds) {
        await fetch(`${BASE_URL}/KULLANICILAR_Advert_Pricing`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Advert_ID: createdAdvertId, Advert_Pricing_ID: pId })
        });
      }

      showAlert("İlan başarıyla yayınlandı!", "success");
      setTimeout(() => {
          navigate("/job-apply"); 
      }, 2000);

    } catch (error) {
      console.error("Yayınlama Hatası Detayı:", error);
      showAlert(error.message || "İşlem sırasında hata oluştu.", "danger");
      setPublishing(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Görevler" breadcrumbItem="Yeni Görev Oluştur" />

          <Alert isOpen={alertConfig.visible} color={alertConfig.type} className="border-0 shadow-sm font-size-15">
            <i className={`mdi ${alertConfig.type === "success" ? "mdi-check-circle" : "mdi-alert-circle"} me-2`}></i>
            {alertConfig.message}
          </Alert>

          {loading ? (
             <div className="text-center py-5">
               <Spinner color="primary" />
             </div>
          ) : (
            <Row>
              <Col lg="8">
                
                {/* 0. KULLANICI SEÇİMİ */}
                <Card className="shadow-sm border border-info rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-3 fw-bold text-info">
                        <i className="mdi mdi-account-tie me-2"></i>Görev Sahibi (Müşteri/Sürücü)
                    </CardTitle>
                    <Input 
                        type="select" 
                        className="form-select bg-soft-info border-info fw-bold text-dark" 
                        value={selectedTaskUser} 
                        onChange={(e) => setSelectedTaskUser(e.target.value)}
                    >
                        <option value="">Lütfen Görevin Atanacağı Kullanıcıyı Seçin...</option>
                        {users.map(u => (
                            <option key={u.ID} value={u.ID}>
                                {u.AD_SOYAD || u.Users_Name} - ({u.Users_Type?.Users_Type_Title || "Bilinmeyen Rol"})
                            </option>
                        ))}
                    </Input>
                  </CardBody>
                </Card>

                {/* 1. GÖREV TİPİ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-briefcase-outline text-primary me-2"></i>Görev Tipi</CardTitle>
                    <div className="d-flex flex-wrap gap-2">
                      {advertTypes.map((type) => (
                        <Button 
                          key={type.ID} 
                          color={advertTypeId === type.ID ? "primary" : "light"}
                          onClick={() => setAdvertTypeId(type.ID)}
                          className="px-4 py-2 fw-bold"
                        >
                          {type.Advert_Type_Title}
                        </Button>
                      ))}
                    </div>
                  </CardBody>
                </Card>

                {/* 2. ROTA PLANLAMASI (OTOMATİK MESAFE EKLENDİ) */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-map-marker-path text-primary me-2"></i>Rota Planlaması</CardTitle>
                    <Row>
                      <Col md="12" className="mb-3">
                        <Label>Başlangıç Adresi</Label>
                        <div className="input-group">
                            <span className="input-group-text bg-light text-success"><i className="mdi mdi-circle-slice-8"></i></span>
                            <Autocomplete
                              apiKey={GOOGLE_API_KEY}
                              className="form-control"
                              placeholder="Yükleme adresi arayın..."
                              defaultValue={startAddress}
                              onChange={(e) => setStartAddress(e.target.value)}
                              onPlaceSelected={(place) => {
                                setStartAddress(place.formatted_address);
                                if (place.geometry?.location) {
                                  setStartLat(place.geometry.location.lat());
                                  setStartLng(place.geometry.location.lng());
                                }
                              }}
                              options={{ types: ["geocode", "establishment"], componentRestrictions: { country: "tr" } }}
                            />
                        </div>
                      </Col>
                      <Col md="12" className="mb-3">
                        <Label>Varış Adresi</Label>
                        <div className="input-group">
                            <span className="input-group-text bg-light text-danger"><i className="mdi mdi-map-marker"></i></span>
                            <Autocomplete
                              apiKey={GOOGLE_API_KEY}
                              className="form-control"
                              placeholder="Teslimat adresi arayın..."
                              defaultValue={endAddress}
                              onChange={(e) => setEndAddress(e.target.value)}
                              onPlaceSelected={(place) => {
                                setEndAddress(place.formatted_address);
                                if (place.geometry?.location) {
                                  setEndLat(place.geometry.location.lat());
                                  setEndLng(place.geometry.location.lng());
                                }
                              }}
                              options={{ types: ["geocode", "establishment"], componentRestrictions: { country: "tr" } }}
                            />
                        </div>
                      </Col>
                      <Col md="6">
                        <Label>Mesafe (KM)</Label>
                        <div className="input-group">
                            <Input type="number" placeholder="Otomatik hesaplanır..." value={km} disabled className="bg-light fw-bold text-primary" />
                            <span className="input-group-text bg-light fw-bold">KM</span>
                        </div>
                        <small className="text-muted mt-1 d-block">Mesafe başlangıç ve varış konumlarına göre otomatik hesaplanır.</small>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* 3. ZAMANLAMA */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-calendar-clock text-primary me-2"></i>Zaman Planlaması</CardTitle>
                    <Row>
                      <Col md="6" className="mb-3">
                        <Label>Başlangıç Tarihi</Label>
                        <FlatPickr
                          className="form-control bg-light border-light"
                          placeholder="Tarih seçin"
                          options={{ dateFormat: "Y-m-d", minDate: "today" }}
                          onChange={(date) => setStartDate(date[0])}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Başlangıç Saati</Label>
                        <Input type="time" className="bg-light border-light" value={timeStart} onChange={e => setTimeStart(e.target.value)} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Bitiş Tarihi</Label>
                        <FlatPickr
                          className="form-control bg-light border-light"
                          placeholder="Tarih seçin"
                          options={{ dateFormat: "Y-m-d", minDate: startDate || "today" }}
                          onChange={(date) => setEndDate(date[0])}
                        />
                      </Col>
                      <Col md="6">
                        <Label>Bitiş Saati</Label>
                        <Input type="time" className="bg-light border-light" value={timeEnd} onChange={e => setTimeEnd(e.target.value)} />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {/* 4. ARAÇ BİLGİLERİ */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <CardTitle className="mb-0 fw-bold"><i className="mdi mdi-car text-primary me-2"></i>Araç Bilgileri</CardTitle>
                        <Input type="select" className="w-auto fw-bold text-primary bg-soft-primary border-primary" value={selectedCarId} onChange={handleCarSelect}>
                            <option value="new">+ Yeni Araç Ekle</option>
                            {cars.map(c => <option key={c.ID} value={c.ID}>{c.PLAKA} ({c.MARKA})</option>)}
                        </Input>
                    </div>

                    <Row>
                      <Col md="12" className="mb-3">
                        <Label>Plaka</Label>
                        <Input type="text" placeholder="Örn: 34 ABC 123" className="fw-bold fs-5 text-uppercase bg-light border-light" value={carForm.carPlate} onChange={e => setCarForm({...carForm, carPlate: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Marka</Label>
                        <Input type="text" placeholder="Örn: BMW" className="bg-light border-light" value={carForm.carBrand} onChange={e => setCarForm({...carForm, carBrand: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="6" className="mb-3">
                        <Label>Model</Label>
                        <Input type="text" placeholder="Örn: 3.20i" className="bg-light border-light" value={carForm.carModel} onChange={e => setCarForm({...carForm, carModel: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="4" className="mb-3">
                        <Label>Kasa Tipi</Label>
                        <Input type="text" placeholder="SUV / Sedan" className="bg-light border-light" value={carForm.carBodyType} onChange={e => setCarForm({...carForm, carBodyType: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="4" className="mb-3">
                        <Label>Motor Tipi</Label>
                        <Input type="text" placeholder="Elektrik vb." className="bg-light border-light" value={carForm.engineType} onChange={e => setCarForm({...carForm, engineType: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                      <Col md="4">
                        <Label>Şase No</Label>
                        <Input type="text" placeholder="WBA123..." className="bg-light border-light" value={carForm.chassisInformation} onChange={e => setCarForm({...carForm, chassisInformation: e.target.value})} disabled={selectedCarId !== "new" && selectedCarId !== ""} />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>


                {/* 5. MÜŞTERİ NOTU */}
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold">
                      <i className="mdi mdi-pencil-box-outline text-primary me-2"></i>Müşteri Notu (İsteğe Bağlı)
                    </CardTitle>
                    <Input 
                      type="textarea" 
                      rows="3" 
                      className="bg-light border-light" 
                      placeholder="Görevle veya araçla ilgili eklemek istediğiniz özel bir not ya da talep var mı?" 
                      value={advertNote} 
                      onChange={e => setAdvertNote(e.target.value)} 
                    />
                  </CardBody>
                </Card>
              </Col>

              {/* SAĞ TARAF - SİPARİŞ ÖZETİ VE EKSTRALAR */}
              <Col lg="4">
                
                <Card className="shadow-sm border rounded-4 mb-4">
                  <CardBody>
                    <CardTitle className="mb-4 fw-bold"><i className="mdi mdi-star-circle-outline text-warning me-2"></i>Ek Hizmetler</CardTitle>
                   {pricingOptions.map(item => (
                    <div 
                        key={item.ID} 
                        className={`p-3 mb-3 border rounded-3 d-flex align-items-center justify-content-between ${selectedExtras[item.ID] ? 'bg-soft-primary border-primary' : 'bg-light border-light'}`}
                        style={{ cursor: "pointer", transition: "all 0.2s" }}
                        onClick={() => {
                            setSelectedExtras(prev => ({
                                ...prev,
                                [item.ID]: !prev[item.ID] 
                            }));
                        }}
                    >
                        <div>
                            <h6 className="fw-bold mb-1">{item.Advert_Pricing_Title}</h6>
                            <p className="text-muted font-size-12 mb-1">{item.Advert_Pricing_Desc}</p>
                            <span className={`fw-bold font-size-13 ${selectedExtras[item.ID] ? 'text-primary' : 'text-secondary'}`}>
                                {item.Price === 0 ? "Ücretsiz" : `+${item.Price} TL`}
                            </span>
                        </div>
                        <div className="form-check form-switch form-switch-md mb-0">
                            <Input 
                                type="checkbox" 
                                className="form-check-input" 
                                style={{ cursor: "pointer", pointerEvents: "none" }} 
                                checked={selectedExtras[item.ID] || false} 
                                onChange={() => {}} 
                            />
                        </div>
                    </div>
                   ))}
                  </CardBody>
                </Card>

                <div style={{ position: "sticky", top: "85px" }}>
                    <Card className="shadow-sm border border-primary rounded-4">
                    <CardBody className="p-4">
                        <h5 className="fw-bold text-center mb-4 text-primary">Görev Özeti</h5>
                        
                        <div className="d-flex justify-content-between mb-3 border-bottom pb-2">
                            <span className="text-muted fw-bold">Baz Ücret ({basePrice} TL/Km)</span>
                            <span className="fw-bold text-dark">{((parseFloat(km)||0) * parseFloat(basePrice)).toFixed(2)} TL</span>
                        </div>

                        <div className="d-flex justify-content-between mb-4 border-bottom pb-2">
                            <span className="text-muted fw-bold">Ek Hizmetler</span>
                            <span className="fw-bold text-dark">
                                {pricingOptions.reduce((sum, item) => sum + (selectedExtras[item.ID] ? parseFloat(item.Price) : 0), 0).toFixed(2)} TL
                            </span>
                        </div>

                        <div className="text-center mb-4">
                            <span className="text-muted font-size-12 fw-bold d-block mb-1">TOPLAM TUTAR</span>
                            <h2 className="text-primary fw-900 mb-0">{totalPrice.toFixed(2)} TL</h2>
                        </div>

                        <Button color="primary" size="lg" className="w-100 fw-bold py-3 shadow d-flex justify-content-between align-items-center" onClick={handlePublish} disabled={publishing}>
                            {publishing ? <Spinner size="sm" color="light" /> : <span>İlanı Yayınla</span>}
                            <i className="mdi mdi-cloud-upload-outline fs-4"></i>
                        </Button>
                    </CardBody>
                    </Card>
                </div>

              </Col>
            </Row>
          )}

        </Container>
      </div>
    </React.Fragment>
  );
};

export default YeniGorevOlustur;